export const INITIALISE_STATIC_DATA = 'companyExperience/INITIALISE_STATIC_DATA'

// Generate our action creators since they are all very similar
const createActionCreator = typeName => initialState => ({
  type: typeName,
  payload: initialState,
})

export const initialiseStaticData = createActionCreator(INITIALISE_STATIC_DATA)

// Generate our reducers since they are all very similar
const createReducer =
  typeName =>
  (state = {}, { type, payload }) => {
    switch (type) {
      case typeName:
        return {
          ...state,
          ...payload,
        }

      default:
        return state
    }
  }

export const staticDataReducer = createReducer(INITIALISE_STATIC_DATA)
